<script setup>
const props = defineProps({
  customClass: String,
  size: String,
});

const sizeClass = ref(
  props.size ? "w-" + props.size + " h-" + props.size : "w-24px h-24px"
);
</script>

<template>
  <svg
    class="icon icon--instagram"
    :class="[sizeClass, customClass]"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 511 511"
    aria-hidden="true"
  >
    <path
      d="M510.5,150.2c-1.2-27.2-5.6-45.8-11.9-62c-6.5-17.2-16.5-32.5-29.5-45.3
	c-12.8-13-28.3-23.1-45.2-29.4c-16.3-6.3-34.8-10.7-62-11.9C334.5,0.3,325.8,0,256.4,0s-78.1,0.3-105.3,1.5
	c-27.2,1.2-45.8,5.6-62,11.9C72,19.9,56.6,29.8,43.8,42.9c-13,12.8-23.1,28.3-29.4,45.2c-6.3,16.3-10.7,34.8-11.9,62
	c-1.3,27.4-1.6,36-1.6,105.4s0.3,78.1,1.5,105.3c1.2,27.2,5.6,45.8,11.9,62c6.5,17.2,16.6,32.5,29.5,45.3
	c12.8,13,28.3,23.1,45.2,29.4c16.3,6.3,34.8,10.7,62,11.9c27.2,1.2,35.9,1.5,105.3,1.5s78.1-0.3,105.3-1.5
	c27.2-1.2,45.8-5.6,62-11.9c34.3-13.3,61.5-40.4,74.8-74.8c6.3-16.3,10.7-34.8,11.9-62c1.2-27.3,1.5-35.9,1.5-105.3
	S511.7,177.5,510.5,150.2z M464.5,358.9c-1.1,25-5.3,38.4-8.8,47.4c-8.6,22.3-26.3,39.9-48.5,48.5c-9,3.5-22.6,7.7-47.4,8.8
	c-27,1.2-35,1.5-103.2,1.5s-76.4-0.3-103.2-1.5c-25-1.1-38.4-5.3-47.4-8.8c-11.1-4.1-21.2-10.6-29.3-19.1
	c-8.5-8.3-15-18.3-19.1-29.3c-3.5-9-7.7-22.6-8.8-47.4c-1.2-27-1.5-35-1.5-103.2s0.3-76.4,1.5-103.2c1.1-25,5.3-38.4,8.8-47.4
	C61.6,94,68.1,84,76.7,75.8c8.3-8.5,18.3-15,29.3-19.1c9-3.5,22.6-7.7,47.4-8.8c27-1.2,35-1.5,103.2-1.5c68.3,0,76.4,0.3,103.2,1.5
	c25,1.1,38.4,5.3,47.4,8.8c11.1,4.1,21.2,10.6,29.3,19.1c8.5,8.3,15,18.3,19.1,29.4c3.5,9,7.7,22.6,8.8,47.4
	c1.2,27,1.5,35,1.5,103.2S465.7,331.9,464.5,358.9z"
    />
    <path
      d="M256.4,124.3c-72.5,0-131.3,58.8-131.3,131.3S184,386.8,256.4,386.8c72.5,0,131.3-58.8,131.3-131.3
	S328.9,124.3,256.4,124.3z M256.4,340.7c-47,0-85.2-38.1-85.2-85.2s38.1-85.2,85.2-85.2c47,0,85.2,38.1,85.2,85.2
	S303.5,340.7,256.4,340.7z"
    />
    <path
      d="M423.6,119.1c0,16.9-13.7,30.6-30.6,30.6c-16.9,0-30.6-13.7-30.6-30.6c0-16.9,13.7-30.6,30.6-30.6
	C409.8,88.4,423.6,102.2,423.6,119.1z"
    />
  </svg>
</template>
